import { Participant, Speaker } from '@typings/participant';
import { Show, ShowServerData } from '@typings/show';
import { User } from '@typings/user';
import { Channel } from '@typings/channel';

import { participantsMapper } from './participants';

export const formatShows = (data: ShowServerData[]) => {
  let allParticipantsData: Record<string, Participant> = {};
  let allUsersData: Record<string, User> = {};
  let allSpeakersData: Record<string, Speaker> = {};
  const allChannelsData: Record<string, Channel> = {};

  const formattedShows: Show[] = data.reduce((acc, show) => {
    const {
      host,
      coHost,
      participants,
      speakers,
      currentTopicId,
      listenersCount,
      channel,
      ...restShow
    } = show;
    const {
      participantsData,
      usersData,
      rightTeamSpeakerId,
      leftTeamSpeakerId,
      speakersData,
    } = participantsMapper(participants, show.id, speakers);

    allParticipantsData = { ...allParticipantsData, ...participantsData };
    allSpeakersData = { ...allSpeakersData, ...speakersData };
    allUsersData = { ...allUsersData, ...usersData };

    if (channel?.id) {
      allChannelsData[channel.id] = channel;
    }

    acc.push({
      ...restShow,
      hostId: host.id,
      coHostId: coHost?.id,
      currentTopicId,
      listenersCount: listenersCount || 0,
      rightTeamSpeakerId,
      leftTeamSpeakerId,
      channelId: channel?.id,
    });
    return acc;
  }, [] as Show[]);

  const ids: string[] = data.map(({ id }) => id);

  return {
    allUsersData,
    allParticipantsData,
    allSpeakersData,
    allChannelsData,
    ids,
    formattedShows,
  };
};
